import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { AsyncPipe, NgIf } from "@angular/common";

import { EventItemModel } from "../../models/event-item.model";
import { BookletService } from "../../services/booklet.service";
import { DirectorySearchService } from "../../../advanced-search/directory-search/services/directory-search.service";
import { DirectoryItemModel } from "../../../advanced-search/directory-search/models/directory-item.model";

@Component({
    selector: "[pcg-ng-booklet-item]",
    templateUrl: "booklet-item.component.html",
    imports: [
        NgIf,
        AsyncPipe
    ],
    standalone: true
})
export class BookletItemComponent implements OnInit {
    @Input() public bookletItem: EventItemModel;
    @Input() public showDetails$: Observable<{showDetails: boolean}>;
    @Input() public showDetails: boolean;

    public directoryItem$: Observable<DirectoryItemModel>;

    public constructor(
        public bookletService: BookletService,
        private directorySearchService: DirectorySearchService
    ) {
    }

    public ngOnInit(): void {
        if (!!this.bookletItem?.eventId) {
            this.directoryItem$ = this.directorySearchService.getDirectoryItem(this.bookletItem.eventId);

        }
    }
}
